import type { EventPayload } from '@side/analytics';

export enum TrackReportsEvent {
  AIInsightsResponseCopy,
  AIInsightsResponsePositive,
  AIInsightsResponseNegative,
}

type EventTypeLabels = Record<TrackReportsEvent, string>;

export const ReportsEventLabels: EventTypeLabels = {
  [TrackReportsEvent.AIInsightsResponseCopy]: 'AI_CHAT_RESULT',
  [TrackReportsEvent.AIInsightsResponsePositive]: 'AI_CHAT_RESULT',
  [TrackReportsEvent.AIInsightsResponseNegative]: 'AI_CHAT_RESULT',
};

type EventTypePayloads = Record<TrackReportsEvent, EventPayload>;

export const ReportsEventMap: EventTypePayloads = {
  [TrackReportsEvent.AIInsightsResponseCopy]: {
    eventContainer: 'reports_performance_ai_insights',
    eventTarget: 'assistant_response_action',
    eventType: 'click',
    task: 'copy',
  },
  [TrackReportsEvent.AIInsightsResponsePositive]: {
    eventContainer: 'reports_performance_ai_insights',
    eventTarget: 'assistant_response_action',
    eventType: 'click',
    task: 'positive_feedback',
  },
  [TrackReportsEvent.AIInsightsResponseNegative]: {
    eventContainer: 'reports_performance_ai_insights',
    eventTarget: 'assistant_response_action',
    eventType: 'click',
    task: 'negative_feedback',
  },
};
